import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useBillingInvoicing } from '../context/BillingInvoicingContext';

const stepKeys = [
  'company-selection',
  'order-selection',
  'billing-item-summary',
  'invoice-creation',
  'invoice-details'
] as const;

const steps = [
  'billing.steps.company_selection',
  'billing.steps.order_selection',
  'billing.steps.billing_item_summary',
  'billing.steps.invoice_creation',
  'billing.steps.invoice_details'
];

type StepKey = typeof stepKeys[number];

const StepperNavigation: React.FC = () => {
  const { t } = useTranslation();
  const { currentStep, setCurrentStep } = useBillingInvoicing();
  const activeStep = stepKeys.indexOf(currentStep as StepKey);

  return (
    <Box
      sx={{
        backgroundColor: 'grey.100',
        borderRadius: 2,
        p: 0,
        boxShadow: 1,
        width: '100%',
        mb: 0
      }}
    >
      <Tabs
        value={activeStep}
        onChange={(_, newValue) => setCurrentStep(stepKeys[newValue])}
        aria-label={t(
          'billing.stepper.aria_label',
          'Billing & Invoicing Steps'
        )}
        variant="fullWidth"
        sx={{ width: '100%', minWidth: 0 }}
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {steps.map((key, index) => (
          <Tab
            key={key}
            label={
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  minWidth: 0,
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}
              >
                <Box
                  sx={{
                    width: 26,
                    height: 28,
                    borderRadius: '50%',
                    bgcolor: activeStep === index ? 'primary.main' : 'grey.300',
                    color: activeStep === index ? 'white' : 'black',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 1,
                    fontWeight: 'bold',
                    fontSize: 16,
                    boxShadow: activeStep === index ? 3 : 0,
                    border: activeStep === index ? '2px solid' : '1px solid',
                    borderColor:
                      activeStep === index ? 'primary.dark' : 'grey.300',
                    transition: 'all 0.2s'
                  }}
                >
                  {index + 1}
                </Box>
                <Box
                  sx={{
                    minWidth: 0,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    fontSize: 13,
                    color:
                      activeStep === index ? 'text.primary' : 'text.secondary'
                  }}
                >
                  {t(key)}
                </Box>
              </Box>
            }
            value={index}
            sx={{ minWidth: 0, textTransform: 'none', px: 0.5 }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default StepperNavigation;
